import { differenceInCalendarDays, format, formatDistanceToNowStrict, isToday, isYesterday, parseISO } from "date-fns";

export { gbp, gbpShort, int, plural } from "@otii/shared";

const toDate = (v: string | Date) => (typeof v === "string" ? parseISO(v) : v);

/** 2 Oct 2026 */
export const fmtDate = (v: string | Date | null | undefined) => (v ? format(toDate(v), "d MMM yyyy") : "—");
/** 2 Oct 2026, 14:05 */
export const fmtDateTime = (v: string | Date | null | undefined) => (v ? format(toDate(v), "d MMM yyyy, HH:mm") : "—");

/** "3 days ago", "today", "yesterday". */
export function ago(v: string | Date | null | undefined): string {
  if (!v) return "never";
  const d = toDate(v);
  if (isToday(d)) return "today";
  if (isYesterday(d)) return "yesterday";
  return `${formatDistanceToNowStrict(d)} ago`;
}

/** Days between a date and today (positive = in the past). */
export const daysSince = (v: string | Date) => differenceInCalendarDays(new Date(), toDate(v));

/** Today's date as YYYY-MM-DD. */
export const todayISO = () => format(new Date(), "yyyy-MM-dd");

/** Value for a datetime-local input, from an ISO string or now. */
export const toLocalInput = (v?: string | Date) => format(v ? toDate(v) : new Date(), "yyyy-MM-dd'T'HH:mm");
/** datetime-local value back to ISO. */
export const fromLocalInput = (v: string) => new Date(v).toISOString();

export const fullName = (c: { firstName: string; lastName: string }) => `${c.firstName} ${c.lastName}`.trim();

export function initials(name: string | null | undefined): string {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] ?? "") + (parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? "") : "")).toUpperCase();
}
